import type {
  FxBreaklineType,
  FxReferenceCategory,
} from '@mobile-mapping/providers';
import type { ProjectDataLoadItemType } from './project-data-load-control';

export type FxWorkspaceTreeItemKind =
  | 'workspace'
  | 'references'
  | 'referenceCategory'
  | 'referenceMission'
  | 'referenceRuns'
  | 'referenceFolder'
  | 'reference'
  | 'pci'
  | 'breaklines'
  | 'breaklineType'
  | 'extractedFeatures'
  | 'job';

export interface FxWorkspaceTreeItem {
  readonly kind: FxWorkspaceTreeItemKind;
  readonly workspaceId: string;
  readonly jobId?: string;
  readonly category?: FxReferenceCategory;
  readonly refTrn?: string;
  readonly layerId?: string;
  readonly loadItemType?: ProjectDataLoadItemType;
  readonly breaklineType?: FxBreaklineType;
}

export function isSaveableFxReference(
  data: FxWorkspaceTreeItem | undefined
): data is FxWorkspaceTreeItem & { kind: 'reference'; refTrn: string } {
  return data?.kind === 'reference' && data.refTrn !== undefined;
}

export function isProjectDataFxReference(
  data: FxWorkspaceTreeItem | undefined
): data is FxWorkspaceTreeItem & {
  kind: 'reference';
  refTrn: string;
  loadItemType: ProjectDataLoadItemType;
} {
  return isSaveableFxReference(data) && data.loadItemType !== undefined;
}

export function isFxMapLayerReference(
  data: FxWorkspaceTreeItem | undefined
): data is FxWorkspaceTreeItem & {
  kind: 'reference';
  category: 'mapWorkspaces';
  refTrn: string;
  layerId: string;
} {
  return (
    isSaveableFxReference(data) &&
    data.category === 'mapWorkspaces' &&
    data.layerId !== undefined
  );
}
